import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../../components/common';
import './UserHomePage.css';

export default function UserHomePage() {
  const navigate = useNavigate();
  
  // State
  const [userName, setUserName] = useState('User');
  const [walletBalance, setWalletBalance] = useState(0);
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastSynced, setLastSynced] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);

  // Get token
  const getToken = () => {
    return localStorage.getItem('authToken') || 
           localStorage.getItem('token') || 
           localStorage.getItem('jwt_token');
  };

  // Fetch user home data
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = getToken();
            console.log('🔑 Sending token:', token ? `${token.slice(0, 20)}...` : 'NO TOKEN');
        if (!token) throw new Error('No token found');

        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL || 'https://viz-sm-be.onrender.com'}/api/v1/user/home`,
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        console.log('✅ User Data:', response.data);

        // ✅ Set state from backend response
        setUserName(response.data.firstName || 'User');
        setWalletBalance(response.data.balance || 0);  // ✅ LOWERCASE "balance"
        setDevices(response.data.devices || []);  // ✅ Array of devices
        setLastSynced(new Date()); // ✅ Set current time
        setError(null);
      } catch (err) {
            console.error('❌ Full error:', {
      status: err.response?.status,
      message: err.message,
      data: err.response?.data
    });
        setError(err.response?.data?.error || 'Failed to load user data');
        setDevices([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  // Navigation handlers
  const handleMenuClick = () => navigate('/sidemenu');
  const handleProfileClick = () => navigate('/profile');
  const handleTopupHistory = () => navigate('/topup-history');
  const handleTopupWallet = () => navigate('/topup-wallet');
  const handleTransferToPool = () => navigate('/transfer-pool');
  const handleLinkDevice = () => navigate('/link-device');
  const handlePoolHistory = () => navigate('/pool-history');
  const handleDeviceAnalytics = (deviceId) => {
    navigate(`/useranalytics?deviceId=${deviceId}`);  // ✅ Matches App.js route
  };


  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      const token = getToken();
      if (!token) throw new Error('No token found');

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000'}/api/v1/user/home`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      setUserName(response.data.firstName || 'User');
      setWalletBalance(response.data.balance || 0);
      setDevices(response.data.devices || []);
      setLastSynced(new Date()); // ✅ Update sync time
      setError(null);
    } catch (err) {
      console.error('❌ Refresh error:', err);
      setError('Failed to refresh data');
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <div className="user-home-root">
      <header className="user-home-header">
        <div className="header-item left">
          <button className="user-home-menu-btn" onClick={handleMenuClick}>
            <i className="fas fa-bars"></i>
          </button>
        </div>
        <div className="header-item center">
          <span className="user-home-greeting">Hi {userName}</span>
        </div>
        <div className="header-item right">
          <button className="user-home-profile-btn" onClick={handleProfileClick}>
            <i className="fas fa-user-circle"></i>
          </button>
        </div>
      </header>

      <div className="user-home-container">
        {/* ✅ FIXED CONTENT */}
        <div className="user-home-fixed-content">


          {/* Wallet Card */}
          <div className="user-home-card wallet-card">
          <div className="card-header">
            <span className="card-link" onClick={handleTopupHistory}>

            Topup History

              </span>
            <div className="card-balance">
              Balance <span className="balance-value">₹{walletBalance.toFixed(2)}</span>
            </div>
          </div>
          <div className="card-title">WALLET</div>
        </div>

        {/* Action Buttons */}
        <div className="action-buttons">
          <Button onClick={handleTopupWallet} className="action-btn">
            Topup WALLET
          </Button>
          <Button onClick={handleTransferToPool} className="action-btn">
            Transfer WALLET to POOL
          </Button>
          <Button onClick={handleLinkDevice} className="action-btn">
            Link Device
          </Button>
        </div>

        {/* Linked Devices */}
        
        </div>
        
        {/* ✅ END FIXED CONTENT */}


        {/* ✅ START SCROLLABLE DEVICES */}
        <div className="user-home-devices-scroll">
          {/* ✅ SECTION TITLE WITH SYNC INFO */}
          <div className="section-title-row">
            <h2 className="section-title">Linked Devices</h2>
            <div className="sync-info-inline">
              <button 
                className="refresh-btn-inline"
                onClick={handleRefresh}
                disabled={isRefreshing}
                title="Refresh data"
              >
                <i className={`fas fa-sync-alt ${isRefreshing ? 'spinning' : ''}`}></i>
              </button>
              <span className="sync-text-inline">
                {lastSynced ? lastSynced.toLocaleString() : 'Loading...'}
              </span>
            </div>
          </div>


        {loading ? (
          <div className="loading">Loading devices...</div>
        ) : error ? (
          <div className="error-message">{error}</div>
        ) : devices.length > 0 ? (
          // ✅ Map all devices
          devices.map((device, index) => (

        <div key={index} className="user-home-card device-card" onClick={() => handleDeviceAnalytics(device.id)}>
          <div className="card-header">
            <span
              className="card-link"
              onClick={(e) => {
                e.stopPropagation();
                handlePoolHistory();
              }}
            >
              Transfer History
            </span>

            {/* ✅ MOVE BALANCE HERE */}
            <div className="card-balance">
              <span className="balance-value">{device.pool || 0} kWh</span>
            </div>
          </div>

          <div className="card-serial">{device.id}</div>
          <div className="card-pool-label">POOL</div>
          <div className={`device-status ${device.isActive ? 'online' : 'offline'}`}></div>
        </div>



          ))
        ) : (
          // ✅ No devices linked
          <div className="user-home-card device-card">
            <div className="card-header">
              <span className="card-link" onClick={handleLinkDevice}>
                Link Device
              </span>
              <div className="card-balance">
                Balance <span className="balance-value">-</span>
              </div>
            </div>
            <div className="card-serial">—</div>
            <div className="card-POOL">No device linked</div>
            <div className="device-status offline"></div>
          </div>
        )}
                </div>
        {/* ✅ END SCROLLABLE DEVICES */}

      </div>
    </div>
  );
}
